import React, { useEffect, useRef, useState } from "react";
import sscImg from "../../assets/test-series-image/ssc.webp";
import rrbImg from "../../assets/test-series-image/rrb.webp";
import mpscImg from "../../assets/test-series-image/mpsc.webp";
import policeImg from "../../assets/test-series-image/police.webp";
import bankImg from "../../assets/test-series-image/bank.webp";
import codingImg from "../../assets/test-series-image/coding.webp";
import campusImg from "../../assets/test-series-image/campus.webp";
import jeeImg from "../../assets/test-series-image/jee.webp";
import { useNavigate } from "react-router-dom";
import "./ExamCards.css";
import { slug as slugify } from "github-slugger";

function ExamCards({ index, test, onAttemptTest }) {
    const [expanded, setExpanded] = useState(false);
    const navigate = useNavigate();
    const cardRef = useRef(null);
    const buttonRef = useRef(null);
    const testSeriesImages = {
        SSC: sscImg,
        RRB: rrbImg,
        MPSC: mpscImg,
        Police: policeImg,
        Banking: bankImg,
        Coding: codingImg,
        Placement: campusImg,
        JEE: jeeImg,
    };
    const testSeriesImage = testSeriesImages[test.testSeries] || null;

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (expanded && 
                cardRef.current && 
                !cardRef.current.contains(event.target) ){
                setExpanded(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [expanded]);

    const toggleExpand = () => {
        setExpanded(!expanded);
    };

    const handleButtonClick = (test) => {
        const slug = slugify(test.testName).substring(0, 60)
        navigate(`/test/${slug}/${test._id}`);
    };

    return (
        <div className={`exam-card-container ${expanded ? 'expanded' : ''}`} ref={cardRef}>
            <div className="exam-card">
                <div className="card-header">
                    {testSeriesImage && (
                        <img src={testSeriesImage} className="exam-card-img" alt={test.testSeries} />
                    )}
                    <h3 className="exam-card-title">{test.testName}</h3>
                </div>

                <div className="card-body">
                    <div className="always-visible">
                        <p className="exam-card-category">📚 {test.category}</p>
                        <p className="exam-card-teacher">👨‍🏫 Created by: {test.teacherName}</p>
                        <p className="exam-card-duration">⏱️ {test.totalMinutes} Minutes</p>
                        <p className="exam-card-questions">❓ {test.questions.length} Questions</p>
                    </div>

                    <div className="card-actions">
                        <button
                            className="exam-card-button"
                            onClick={()=>handleButtonClick(test)}
                        >
                            Attempt Now
                            </button>

                        <button
                            className="view-more-btn"
                            onClick={toggleExpand}
                            ref={buttonRef}
                        >
                            {expanded ? 'View Less' : 'View More'}
                        </button>
                    </div>
                </div>
            </div>

            <div className="extra-info">
                <p className="exam-card-marks">📝 Total Marks: {test.totalMarks}</p>
                <p className="exam-card-series">🏷️ Test Series: {test.testSeries}</p>
                {test.passingMarks && (
                    <p className="exam-card-passing">✅ Passing Marks: {test.passingMarks}</p>
                )}
                {test.description && (
                    <p className="exam-card-desc">📌 {test.description}</p>
                )}
            </div>

            {/* Click outside overlay */}
            {expanded && <div className="extra-info-overlay" onClick={() => setExpanded(false)} />}
        </div>
    );
}

export default ExamCards;